export const voiceAgent = {
  header: {
    title: "Agent vocal IA",
    subBefore: "Répond à vos appels téléphoniques grâce à l'IA en temps réel. S'applique à",
    subEmphasis: "l'ensemble de votre compte",
    active: "Actif",
    inactive: "Inactif",
  },
  loading: "Chargement de la configuration…",
  errors: {
    load: "Impossible de charger la configuration.",
    save: "Impossible d'enregistrer. Veuillez réessayer.",
  },
  phone: {
    title: "Numéro de téléphone",
    desc: "Le numéro que vos clients appellent. Un numéro dédié est créé pour votre compte.",
    checking: "Vérification de votre numéro…",
    pendingTitle: "Téléphonie en attente d'activation",
    pendingText: "La création de numéro n'est pas encore activée sur votre compte. Contactez-nous et nous l'activerons.",
    activeCountry: "Actif · pays {country}",
    provisioning: "Mise en service… (peut prendre quelques minutes)",
    release: "Libérer",
    numberCountry: "Pays du numéro",
    searching: "Recherche…",
    seeAvailable: "Voir les disponibles",
    perMonth: "{cost}/mois",
    getThis: "Obtenir ce numéro",
    getOne: "Obtenir un numéro",
    confirmRelease: "Êtes-vous sûr de vouloir libérer le numéro ? Il cessera de recevoir des appels.",
    errNoneInCountry: "Aucun numéro disponible dans ce pays pour le moment.",
    errTelnyxInactive: "La téléphonie n'est pas encore active sur votre compte.",
    errSearchFailed: "Impossible de rechercher des numéros.",
    errTelnyxInactiveContact: "La téléphonie n'est pas encore active sur votre compte. Contactez-nous et nous l'activerons.",
    errNoNumbersNow: "Aucun numéro disponible pour le moment.",
    errProvisionFailed: "Impossible d'obtenir le numéro.",
    errReleaseFailed: "Impossible de libérer le numéro.",
  },
  voiceLang: {
    title: "Voix et langue",
    assistantVoice: "Voix de l'assistant",
    recommended: "(recommandé)",
    listenVoiceTitle: "Écouter la voix {voice}",
    loading: "Chargement…",
    stop: "Arrêter",
    listen: "Écouter",
    mainLanguage: "Langue principale",
    extraLanguages: "Langues supplémentaires qu'il peut parler",
    useIdentityTitle: "Utiliser l'identité de l'agent de chat",
    useIdentityDesc: "Réutilise le nom, la personnalité et le ton que vous avez déjà définis dans les Paramètres généraux.",
    voiceAssistantName: "Nom de l'assistant vocal",
    namePlaceholder: "ex. réception Málaga Centro Suites",
    greeting: "Message d'accueil au décrochage",
    optional: "(facultatif)",
    greetingPlaceholder: "Si laissé vide, l'assistant accueille automatiquement avec son identité.",
    errPlayback: "Impossible de lire l'échantillon.",
    errGenerate: "Impossible de générer l'échantillon vocal. Veuillez réessayer.",
  },
  languages: {
    es: "Espagnol",
    en: "Anglais",
    fr: "Français",
    pt: "Portugais",
    it: "Italien",
    de: "Allemand",
    ar: "Arabe",
  },
  countries: {
    ES: "Espagne",
    US: "États-Unis",
    GB: "Royaume-Uni",
    FR: "France",
    IT: "Italie",
    DE: "Allemagne",
    PT: "Portugal",
    CO: "Colombie",
    MX: "Mexique",
  },
  days: {
    mon: "Lun",
    tue: "Mar",
    wed: "Mer",
    thu: "Jeu",
    fri: "Ven",
    sat: "Sam",
    sun: "Dim",
  },
  listings: {
    title: "Hébergements pour lesquels il répond",
    desc: "Choisissez les hébergements pour lesquels l'agent vocal répond aux appels.",
    all: "Tous les hébergements",
    some: "Seulement certains",
    scopeNoteBefore: "Il répond pour",
    scopeNoteStrong: "tous",
    scopeNoteAfter: "les hébergements du compte, y compris ceux que vous ajouterez à l'avenir.",
    searchPlaceholder: "Rechercher un hébergement…",
    selectAll: "Tout sélectionner",
    clearAll: "Tout effacer",
    loadingListings: "Chargement des hébergements…",
    noListings: "Ce compte n'a aucun hébergement.",
    noMatches: "Aucun résultat.",
    noneWarn: "Si vous n'en sélectionnez aucun, l'agent répondra pour tous.",
    allDesc: "Y compris ceux que vous ajouterez plus tard.",
    someDesc: "Uniquement ceux que vous cochez ci-dessous.",
    selectedShort: "{n} sur {total}",
  },
  capabilities: {
    title: "Ce qu'il peut faire",
    knowledgeTitle: "Où il trouve ses informations",
    knowledgeDesc: "Choisissez ce que l'assistant consulte quand on l'interroge sur le logement.",
    messagesTitle: "Prendre des messages",
    messagesDesc: "S'il ne sait pas quelque chose, il prend le message du client et vous en informe.",
    linksTitle: "Envoyer des liens après l'appel",
    linksDesc: "Après avoir raccroché, il envoie le lien utile (check-in ou réservation) via WhatsApp lorsque c'est pertinent.",
    photosTitle: "Envoyer les photos des équipements et commodités",
    photosDesc: "Si l'appelant demande un équipement qui a des photos, l'agent les envoie par WhatsApp au numéro depuis lequel il appelle.",
  },
  doc: {
    title: "Document avec des informations",
    desc: "Importez un PDF ou un Word et l'agent pourra répondre avec ce qu'il contient.",
    dropTitle: "Importer un document",
    dropHint: "PDF ou Word (.docx), jusqu'à 15 Mo",
    uploading: "Import du document…",
    replace: "Remplacer",
    remove: "Retirer",
    chars: "{n} caractères lus",
    noText: "Ce document est scanné : ce sont des images, le texte ne peut pas être lu. Importez-en un avec du vrai texte.",
    errType: "Le fichier doit être un PDF ou un Word (.docx).",
    errSize: "Le fichier ne peut pas dépasser 15 Mo.",
    errUpload: "Le document n'a pas pu être importé. Réessayez.",
    errRemove: "Le document n'a pas pu être retiré. Réessayez.",
    fuenteBase: "La base de connaissances",
    fuenteBaseDesc: "Les informations de vos logements : arrivée, services, règles et FAQ.",
    fuenteDoc: "Un document à vous",
    fuenteDocDesc: "Uniquement le PDF ou Word que vous téléversez ci-dessous, avec ses consignes.",
    fuenteAmbas: "Les deux",
    fuenteAmbasDesc: "D'abord le document puis, si la réponse n'y est pas, les informations du logement.",
    verTexto: "Voir ce que lit l'assistant",
    abrirOriginal: "Ouvrir le document",
    previewTitle: "Ce que l'assistant lit de votre document",
    previewSub: "C'est le texte extrait du fichier. S'il manque quelque chose ici, l'assistant ne le sait pas non plus.",
    previewVacio: "Aucun texte n'a pu être extrait de ce fichier.",
    cerrar: "Fermer",
    noUsado: "Il est téléversé, mais l'assistant ne l'utilise pas pour l'instant : vous avez choisi de répondre uniquement avec la base de connaissances.",
    faltaDoc: "Téléversez un document pour pouvoir le choisir comme source.",
  },
  hours: {
    title: "Heures de service",
    specific: "Horaires spécifiques",
    closed: "Fermé",
    afterHours: "En dehors des heures d'ouverture",
    afterVoicemail: "Prendre un message vocal",
    afterMessage: "Diffuser un message et raccrocher",
    afterMessagePlaceholder: "Message diffusé en dehors des heures d'ouverture.",
  },
  recording: {
    title: "Enregistrement et conformité",
    recordTitle: "Enregistrer les appels",
    recordDesc: "Enregistre l'audio des appels afin que vous puissiez le consulter.",
    noticeTitle: "Annoncer l'enregistrement",
    noticeDesc: "L'assistant indique au début que l'appel peut être enregistré (recommandé au titre du RGPD).",
    transcribeTitle: "Transcrire les appels",
    transcribeDesc: "Génère un texte de chaque conversation.",
    transcribeNeedsRecord: "La transcription est tirée de l'audio : si « Enregistrer les appels » est désactivé, aucune n'est générée.",
  },
  advanced: {
    title: "Avancé",
    maxDuration: "Durée maximale de l'appel",
    minutesOption: "{n} minutes",
    aiEngine: "Moteur d'IA",
  },
  save: {
    saved: "Enregistré ✓",
    save: "Enregistrer les modifications",
    dirty: "Vous avez des modifications non enregistrées",
    clean: "Tout est enregistré",
  },
  credits: {
    title: `Minutes d'appel`,
    desc: "Minutes incluses chaque mois selon vos logements. Une fois épuisées, rechargez quand vous voulez.",
    loading: "Chargement du solde…",
    minutesLeft: "min disponibles",
    recharge: "Recharger",
    includedThisMonth: "{used} sur {total} min incluses utilisées ce mois-ci",
    purchased: "{min} min achetées",
    empty: `Vous n'avez plus de minutes. Rechargez pour continuer à recevoir des appels.`,
    error: "Impossible de charger le solde.",
    modal: {
      title: "Recharger des minutes",
      sub: "Choisissez un pack. Le paiement est unique et les minutes sont ajoutées à votre solde immédiatement.",
      pay: "Payer par carte",
      secure: "Paiement sécurisé avec Stripe.",
      close: "Fermer",
      error: "Impossible de démarrer le paiement. Réessayez.",
    },
  },
};
